export default "__VITE_ASSET__f8ce25a0__"